import tbrLogo from "@/assets/logos/tbr-logo.png";
import { cn } from "@/lib/utils";

export function BrandLogo({ className, label = "TBR Distribuidora" }: { className?: string; label?: string }) {
  return (
    <span
      aria-label={label}
      role="img"
      className={cn("inline-block shrink-0 bg-[#ed1c24]", className)}
      style={{
        WebkitMaskImage: `url(${tbrLogo})`,
        maskImage: `url(${tbrLogo})`,
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskSize: "145% auto",
        maskSize: "145% auto",
      }}
    />
  );
}
